/**
 * Created by staffanrantzow on 21/09/16.
 */

import axios from 'axios';
import Service from '../service/service';
import AgreementWrapperEntity from './agreement-wrapper-entity';
import AgreementEntity from './agreement-entity';
import {APIResult} from '../http';
import PendingRequestEntity from '../entities/pending-request-entity';

class AgreementService extends Service {

  hydrateAgreement (agreement) {
    return new AgreementEntity(
      agreement.id,
      agreement.attributes.created_at,
      agreement.attributes.invoice_id,
      agreement.attributes.text,
      agreement.attributes.type_id,
      agreement.attributes.pdf_url,
    );
  }

  hydrateWrapper (agreement, condition) {
    return (new AgreementWrapperEntity(
      this.hydrateAgreement(agreement),
      new AgreementEntity(
        condition.id,
        condition.attributes.created_at,
        condition.attributes.invoice_id,
        condition.attributes.text,
        condition.attributes.type_id,
        condition.attributes.pdf_url,
      )
    ));
  }

  hydrateCollection (data) {
    let agreements = [];
    let conditions = [];
    let returnArr = [];

    // Separate agreements from conditions
    for (let agreement of data) {
      if (agreement.attributes.type_id === 1) {
        agreements.push(agreement);
      } else if (agreement.attributes.type_id === 2) {
        conditions.push(agreement);
      }
    }

    for (let agreement of agreements) {
      for (let condition of conditions) {
        if (agreement.attributes.invoice_id === condition.attributes.invoice_id) {
          returnArr.push(this.hydrateWrapper(agreement, condition));
        }
      }
    }

    return returnArr;
  }

  getById (id) {
    return axios.get(`backend://agreements/${id}`)
      .then((response) => {
        return this.hydrateAgreement(response.data.data);
      });
  }

  get (dateFilter, page, userid) {
    let filter = this.getFilterDate(dateFilter, 'created_at');
    let pendingRequest = new PendingRequestEntity();
    let userRoute = userid ? 'users/' + userid + '/' : '';
    pendingRequest.promise = axios.get(
      'backend://' + userRoute + 'agreements?filter[with_approved_type_status_invoice]' + filter,
      { params: {
        'page[number]': page || 1,
        'page[size]': 10,
        'sort': '-invoice_id'
      },
        cancelToken: new axios.CancelToken(function executor (c) {
          pendingRequest.cancel = c;
        })
      })
    .then((response) => {
      let agreements = this.hydrateCollection(response.data.data);
      return new APIResult(agreements, response.data.meta);
    });

    return pendingRequest;
  }

}

export default new AgreementService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/agreements/agreement-service.js
 **/